/**
 * This is a reducer - a function that takes a current state value and an
 * action object describing "what happened", and returns a new state value.
 * A reducer's function signature is: (state, action) => newState
 *
 * The Redux state should contain only plain JS objects, arrays, and primitives.
 * The root state value is usually an object. It's important that you should
 * not mutate the state object, but return a new object if the state changes.
 *
 * You can use any conditional logic you want in a reducer. In this example,
 * we use a switch statement, but it's not required.
 */

const swapRecipe = (old, index, key) => {
  const keys = [...old]
  keys[index] = key

  return keys
}

const buildState = (overrides = {}) => ({
  keys: [0, 1, 2, 3, 4],
  shoppingList: {},
  ...overrides,
})

const Reducer = (state = buildState(), action) => {
  switch (action.type) {
    case 'SET_RECIPES':
      return buildState({ keys: action.keys })
    case 'SWAP_RECIPE':
      return buildState({
        keys: swapRecipe(state.keys, action.index, action.key),
      })
    case 'TOGGLE_INGREDIENT':
      return {
        ...state,
        shoppingList: {
          ...state.shoppingList,
          [action.ingredient]: !state.shoppingList[action.ingredient],
        },
      }
    default:
      return state
  }
}

export default Reducer
